import i18n from '@base/i18n'

export const host = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_DOMAIN : 'localhost:8000'

export const wsHost = `wa://${host}/`

// Envs which we will use for our app, deployed to Google Play and App Store
const standaloneAppSchemeEnvs = ['PRODUCTION']
export const useStandaloneMobileAppScheme = standaloneAppSchemeEnvs.includes(process.env.VUE_APP_SERVER_TYPE)

// In which envs we are using deep linking for mobile app
const mobileAppSchemeEnvs = ['DEV', 'STAGING']
export const useMobileAppScheme = mobileAppSchemeEnvs.includes(process.env.VUE_APP_SERVER_TYPE)

const getMobileAppScheme = () => {
  if (useStandaloneMobileAppScheme)
    return 'flea-lover://'
  if (process.env.VUE_APP_SERVER_TYPE === 'STAGING')
    return 'exp://exp.host/@arossoftware/flea-lover/--'
  if (process.env.VUE_APP_SERVER_TYPE === 'DEV')
    return `exp://${process.env.VUE_APP_LOCAL_IP}/--`
}

export const mobileAppScheme = getMobileAppScheme()

export const webConfig = {
  baseURL: process.env.NODE_ENV === 'production' ? `https://${host}` : `https://${host}`,
}
export const userConfig = {
  baseURL: `${webConfig.baseURL}/accounts`
}

export const marketConfig = {
  baseURL: `${webConfig.baseURL}/markets`
}

export const apiConfig = {
  baseURL: `${webConfig.baseURL}/api/v1`
}

export const adminApiConfig = {
  baseURL: `${apiConfig.baseURL}/admin`
}

export const userApiConfig = {
  baseURL: `${apiConfig.baseURL}/user`
}

export const IS_GLOBAL_APP = process.env.VUE_APP_GLOBAL_APP ? process.env.VUE_APP_GLOBAL_APP.toLowerCase() === 'true' : false

export const loaderOptions = {
  color: '#4b8bff',
  backgroundColor: '#000',
  opacity: 0.1
}

export const RECAPTCHA_SITE_KEY = process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY

export const INSTAGRAM_APP_ID = process.env.VUE_APP_INSTAGRAM_APP_ID

export const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY

const USE_RECAPTCHA_ENVS = ['PRODUCTION']
export const USE_RECAPTCHA = USE_RECAPTCHA_ENVS.includes(process.env.VUE_APP_SERVER_TYPE)

export const TIME_TOKEN_REFRESH_MILLISECONDS = 100 * 86400 * 1000  // Token will refresh in 100 days

export const REDIRECT_COUNTDOWN_SECONDS = 4

export const USER = 1
export const ADMIN = 2

export const GATEWAY_ELAVON = 'elavon'
export const GATEWAY_STRIPE = 'stripe'
export const GATEWAY_SUMUP = 'sumup'
export const GATEWAY_PAYPAL = 'paypal'

export const USER_TYPES = {
  USER: USER,
  ADMIN: ADMIN,
}

export const USER_TYPE_OPTIONS = [
  { name: i18n.t(`admin.multiselect.single_label.user_type.${USER}`), type: USER },
  { name: i18n.t(`admin.multiselect.single_label.user_type.${ADMIN}`), type: ADMIN },
]

export const APP_DOMAIN = IS_GLOBAL_APP ? 'app.flealover.com' : 'loppeonline.dk'
export const APP_NAME = IS_GLOBAL_APP ? 'Flea Lover' : 'LoppeOnline'
export const SYSTEM_NAME = IS_GLOBAL_APP ? 'Flea Lover' : 'NoviPOS'

// Barcode settings
export const BARCODE_QUANTITY = 65
export const BARCODE_COLUMNS = 5

// Field length settings
export const MIN_NAME_FIELD_LENGTH = 4
export const MAX_NAME_FIELD_LENGTH = 20
export const MIN_USERNAME_LENGTH = 4
export const MAX_USERNAME_LENGTH = 20
export const MIN_PASSWORD_LENGTH = 8
export const MIN_POSTAL_CODE_LENGTH = 3
export const MAX_POSTAL_CODE_LENGTH = 12
export const MAX_BANK_ACCOUNT_LENGTH = 10
export const MAX_BANK_ACCOUNT_NORWAY_LENGTH = 11
export const MAX_BANK_ACCOUNT_GB_LENGTH = 8
export const MAX_IBAN_LENGTH = 34
export const IBAN_LENGTHS = {
  AD: 24, AE: 23, AL: 28, AO: 25, AT: 20, AZ: 28, BA: 20, BE: 16, BF: 28, BG: 22,
  BH: 22, BI: 27, BJ: 28, BR: 29, BY: 28, CF: 27, CG: 27, CH: 21, CI: 28, CM: 27,
  CR: 22, CV: 25, CY: 28, CZ: 24, DE: 22, DJ: 27, DK: 18, DO: 28, DZ: 24, EE: 20,
  EG: 29, ES: 24, FI: 18, FK: 18, FO: 18, FR: 27, GA: 27, GB: 22, GE: 22, GI: 23,
  GL: 18, GQ: 27, GR: 27, GT: 28, GW: 25, HN: 28, HR: 21, HU: 28, IE: 22, IL: 23,
  IQ: 23, IR: 26, IS: 26, IT: 27, JO: 30, KM: 27, KW: 30, KZ: 20, LB: 28, LC: 32,
  LI: 21, LT: 20, LU: 20, LV: 21, LY: 25, MA: 28, MC: 27, MD: 24, ME: 22, MG: 27,
  MK: 19, ML: 28, MN: 20, MR: 27, MT: 31, MU: 30, MZ: 25, NE: 28, NI: 28, NL: 18,
  NO: 15, OM: 23, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, RU: 33,
  SA: 24, SC: 31, SD: 18, SE: 24, SI: 19, SK: 24, SM: 27, SN: 28, SO: 23, ST: 25,
  SV: 28, TD: 27, TG: 28, TL: 23, TN: 24, TR: 26, UA: 29, VA: 22, VG: 24, XK: 20,
  YE: 30,
}
export const BANK_REG_NUMBER_LENGTH = 4
export const GB_BANK_REG_NUMBER_LENGTH = 6

export const MIN_SHELF_AMOUNT = 1
export const MAX_SHELF_AMOUNT = 1000

export const MAX_SCREEN_WIDTH_MOBILE = 575
export const ECONOMIC_COUNTRIES_ARRAY = ['DK', 'SE', 'GL']
export const COUNTRIES_ARRAY_ONLY = IS_GLOBAL_APP ? ['GB', 'DE', 'DK', 'SE', 'NO', 'GL', 'BR', 'FI', 'FR', 'IT', 'MX', 'NL', 'ES', 'US'] : ['DK', 'SE', 'NO', 'GL']
export const PHONE_DEFAULT_COUNTRY_CODE = 'DK'
export const PHONE_COUNTRY_CODE_MAPPING = {
  DA: 'DK',
  DE: 'DE',
  EN: 'GB',
}
export const PHONE_NUMBER_INPUT_TRANSLATIONS = {
    DA: {
      countrySelectorLabel: 'Landekode',
      countrySelectorError: 'Vælg et land',
      phoneNumberLabel: 'Telefonnummer',
      example: 'Eksempel:'
    },
    EN: {
      countrySelectorLabel: 'Country Code',
      countrySelectorError: 'Select a country',
      phoneNumberLabel: 'Phone number',
      example: 'Example:'
    },
    DE: {
      countrySelectorLabel: 'Ländervorwahl',
      countrySelectorError: 'Land auswählen',
      phoneNumberLabel: 'Telefonnummer',
      example: 'Beispiel:'
    }
}
export const LANGUAGES = [
  {
    name: i18n.t('multiselect.single_label.language.da'),
    code: 'da',
  },
  {
    name: i18n.t('multiselect.single_label.language.de'),
    code: 'de',
  },
  {
    name: i18n.t('multiselect.single_label.language.en'),
    code: 'en',
  },
  {
    name: i18n.t('multiselect.single_label.language.sv'),
    code: 'sv',
  },
  {
    name: i18n.t('multiselect.single_label.language.es'),
    code: 'es',
  },
  {
    name: i18n.t('multiselect.single_label.language.fr'),
    code: 'fr',
  },
  {
    name: i18n.t('multiselect.single_label.language.nb'),
    code: 'nb',
  },
  {
    name: i18n.t('multiselect.single_label.language.it'),
    code: 'it',
  },
  {
    name: i18n.t('multiselect.single_label.language.nl'),
    code: 'nl',
  },
  {
    name: i18n.t('multiselect.single_label.language.pl'),
    code: 'pl',
  },
  {
    name: i18n.t('multiselect.single_label.language.pt'),
    code: 'pt',
  },
  {
    name: i18n.t('multiselect.single_label.language.fi'),
    code: 'fi',
  },
]
export const NORWAY_COUNTRY = 'NO'
export const GB_COUNTRY = 'GB'
export const GERMANY_COUNTRY = 'DE'
export const FINLAND_COUNTRY = 'FI'
export const DENMARK_COUNTRY = 'DK'
// Only the classic country-based formats read these; the new IBAN format ignores them (isIbanBankFormat).
export const CLASSIC_FORMAT_IBAN_COUNTRIES = [GERMANY_COUNTRY, FINLAND_COUNTRY]
export const CLASSIC_FORMAT_NO_REG_NUMBER_COUNTRIES = [NORWAY_COUNTRY, ...CLASSIC_FORMAT_IBAN_COUNTRIES]

export const AVAILABLE_COUNTRIES = [
  {
    name: i18n.t('multiselect.single_label.country.dk'),
    code: 'DK',
    genericProductNameUsed: 'Kommissionssalg (brugt)',
    genericProductNameNew: 'Kommissionssalg'
  },
  {
    name: i18n.t('multiselect.single_label.country.se'),
    code: 'SE',
    genericProductNameUsed: 'Provisionsförsäljning (begagnad vara)',
    genericProductNameNew: 'Provisionsförsäljning'
  },
  {
    name: i18n.t('multiselect.single_label.country.no'),
    code: 'NO',
    genericProductNameUsed: 'Kommissionssalg (brukt)',
    genericProductNameNew: 'Kommissionssalg'
  },
  {
    name: i18n.t('multiselect.single_label.country.gl'),
    code: 'GL',
    genericProductNameUsed: 'Kommissionssalg (brugt)',
    genericProductNameNew: 'Kommissionssalg'
  },
]
if (IS_GLOBAL_APP) {
  AVAILABLE_COUNTRIES.push(...[
    {
      name: i18n.t('multiselect.single_label.country.gb'),
      code: 'GB',
      genericProductNameUsed: 'Commissioned sale (used)',
      genericProductNameNew: 'Commissioned sale'
    },
    {
      name: i18n.t('multiselect.single_label.country.de'),
      code: 'DE',
      genericProductNameUsed: 'Kommissionsverkäufe (gebraucht)',
      genericProductNameNew: 'Kommissionsverkäufe'
    },
    {
      name: i18n.t('multiselect.single_label.country.br'),
      code: 'BR',
      genericProductNameUsed: 'Ventas por comisión (usado)',
      genericProductNameNew: 'Ventas a comisión'
    },
    {
      name: i18n.t('multiselect.single_label.country.fi'),
      code: 'FI',
      genericProductNameUsed: 'Välitysmyynti (käytetty)',
      genericProductNameNew: 'Komission myynti'
    },
    {
      name: i18n.t('multiselect.single_label.country.fr'),
      code: 'FR',
      genericProductNameUsed: 'Ventes à commission (occasion)',
      genericProductNameNew: 'Ventes à commission'
    },
    {
      name: i18n.t('multiselect.single_label.country.it'),
      code: 'IT',
      genericProductNameUsed: 'Vendite su commissione (usato)',
      genericProductNameNew: 'Vendite su commissione'
    },
    {
      name: i18n.t('multiselect.single_label.country.mx'),
      code: 'MX',
      genericProductNameUsed: 'Ventas por comisión (usado)',
      genericProductNameNew: 'Ventas a comisión'
    },
    {
      name: i18n.t('multiselect.single_label.country.nl'),
      code: 'NL',
      genericProductNameUsed: 'Commissieverkoop (gebruikt)',
      genericProductNameNew: 'Verkoop op commissiebasis'
    },
    {
      name: i18n.t('multiselect.single_label.country.es'),
      code: 'ES',
      genericProductNameUsed: 'Ventas por comisión (usado)',
      genericProductNameNew: 'Ventas a comisión'
    },
    {
      name: i18n.t('multiselect.single_label.country.us'),
      code: 'US',
      genericProductNameUsed: 'Commission sales (used)',
      genericProductNameNew: 'Commission sales'
    },
  ])
}

export const BOOLEAN_OPTIONS = [
  { value: true, name: i18n.t('multiselect.single_label.boolean.true') },
  { value: false, name: i18n.t('multiselect.single_label.boolean.false') }
]

export const USED = 1
export const NEW = 2
export const USED_PREFIX = "kb"
export const NEW_PREFIX = "kn"

export const VAT_RATE_TYPES = [
  {
    type: USED, name: i18n.t(`multiselect.single_label.customers.vat_rate.${USED}`),
    prefix: 'kb'
  },
  {
    type: NEW, name: i18n.t(`multiselect.single_label.customers.vat_rate.${NEW}`),
    prefix: 'kn'
  },
]

export const ISO_CURRENCIES = [
  "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN",
  "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL",
  "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHF", "CLP", "CNY",
  "COP", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP",
  "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD",
  "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS",
  "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR",
  "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD",
  "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU",
  "MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK",
  "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG",
  "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK",
  "SGD", "SHP", "SLL", "SOS", "SRD", "STN", "SVC", "SYP", "SZL", "THB",
  "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX",
  "USD", "UYU", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XCD", "XOF",
  "XPF", "YER", "ZAR", "ZMW", "ZWL",
]

export const VAT_PERCENTS = {
  DK: [{ value: 0, name: "0%" }, { value: 25, name: "25%" }],
  SE: [{ value: 0, name: "0%" }, { value: 25, name: "25%" }],
  NO: [{ value: 0, name: "0%" }, { value: 25, name: "25%" }],
  GL: [{ value: 0, name: "0%" }, { value: 25, name: "25%" }],
  GB: [{ value: 0, name: "0%" }, { value: 20, name: "20%" }],
  DE: [{ value: 0, name: "0%" }, { value: 7, name: "7%" }, { value: 19, name: "19%" }],
  BR: [{ value: 0, name: "0%" }, { value: 12, name: "12%" }, { value: 17, name: "17%", }],
  FI: [{ value: 0, name: "0%" }, { value: 10, name: "10%" }, { value: 14, name: "14%" }, { value: 25.5, name: "25.5%" }],
  FR: [{ value: 0, name: "0%" }, { value: 10, name: "10%" }, { value: 20, name: "20%", }],
  IT: [{ value: 0, name: "0%" }, { value: 10, name: "10%" }, { value: 22, name: "22%", }],
  MX: [{ value: 0, name: "0%" }, { value: 8, name: "8%" }, { value: 11, name: "11%" }, { value: 16, name: "16%" }],
  NL: [{ value: 0, name: "0%" }, { value: 9, name: "9%" }, { value: 21, name: "21%", }],
  ES: [{ value: 0, name: "0%" }, { value: 10, name: "10%" }, { value: 21, name: "21%", }],
  US: [{ value: 0, name: "0%" }],
}

// FleaLover Solo - payment methods. Mirrors apps/sales/models.py
// MarketSoloReceipt.PAYMENT_METHOD_CHOICES; do not let these drift.
export const SOLO_PAYMENT_CASH = 1
export const SOLO_PAYMENT_CARD = 2
export const SOLO_PAYMENT_OTHER = 3
export const SOLO_PAYMENT_METHODS = [
  SOLO_PAYMENT_CASH,
  SOLO_PAYMENT_CARD,
  SOLO_PAYMENT_OTHER,
]

// Tile-button accent colour palette for MarketSoloProduct + Category. Mirrors
// apps/products/models.py SOLO_BUTTON_COLOR_CHOICES.
export const SOLO_BUTTON_COLORS = [
  "blue", "green", "red", "orange",
  "yellow", "purple", "pink", "gray",
]

export const SOLO_PAYMENT_METHOD_ICONS = [
  "cash-stack", "credit-card", "wallet2", "phone", "bank",
  "gift", "tag", "qr-code", "coin", "receipt",
]

// MarketSoloProduct.STATUS_CHOICES mirror - keep in sync with
// apps/products/models.py MarketSoloProduct.ACTIVE / INACTIVE.
export const SOLO_PRODUCT_STATUS_ACTIVE = 1
export const SOLO_PRODUCT_STATUS_INACTIVE = 2

const MONDAY = 1
const TUESDAY = 2
const WEDNESDAY = 3
const THURSDAY = 4
const FRIDAY = 5
const SATURDAY = 6
const SUNDAY = 7

export const OPENING_HOURS = [
  {
    weekdayCode: MONDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${MONDAY}`),
    fromHour: '',
    toHour: ''
  },
  {
    weekdayCode: TUESDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${TUESDAY}`),
    fromHour: '',
    toHour: ''
  },
  {
    weekdayCode: WEDNESDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${WEDNESDAY}`),
    fromHour: '',
    toHour: ''
  },
  {
    weekdayCode: THURSDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${THURSDAY}`),
    fromHour: '',
    toHour: ''
  },
  {
    weekdayCode: FRIDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${FRIDAY}`),
    fromHour: '',
    toHour: ''
  },
  {
    weekdayCode: SATURDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${SATURDAY}`),
    fromHour: '',
    toHour: ''
  },
  {
    weekdayCode: SUNDAY,
    weekdayName: i18n.t(`multiselect.single_label.weekday.${SUNDAY}`),
    fromHour: '',
    toHour: ''
  },
]

export const BOOKING_RESERVED = "reserved"
export const BOOKING_EXPIRED = "expired"
export const BOOKING_PAYMENT_INITIATED = "payment_initiated"

// Reservation hold windows (mirror the backend BOOKING_*_EXPIRY_MINUTES).
export const BOOKING_RESERVE_EXPIRY_SECONDS = 900
export const BOOKING_PAYMENT_EXPIRY_SECONDS = 2700
export const BOOKING_PAID = "paid"
export const BOOKING_REFUNDED = "refunded"
export const BOOKING_REFUND_INITIATED = "refund_initiated"
export const BOOKING_REFUND_FAILED = "refund_failed"
export const PAYMENT_ERROR = "payment_error"
export const BOOKING_CONFIRMED = "confirmed"
export const BOOKING_BOOKED_WITHOUT_PAYMENT = "booked_without_payment"
export const BOOKING_CONFIRMED_WITHOUT_PAYMENT = "confirmed_without_payment"

export const BOOKING_REQUEST_STATUSES = [
  {
    code: BOOKING_RESERVED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_RESERVED}`),
  },
  {
    code: BOOKING_EXPIRED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_EXPIRED}`),
  },
  {
    code: BOOKING_PAYMENT_INITIATED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_PAYMENT_INITIATED}`),
  },
  {
    code: BOOKING_PAID,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_PAID}`),
  },
  {
    code: BOOKING_REFUNDED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_REFUNDED}`),
  },
  {
    code: BOOKING_REFUND_INITIATED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_REFUND_INITIATED}`),
  },
  {
    code: BOOKING_REFUND_FAILED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_REFUND_FAILED}`),
  },
  {
    code: PAYMENT_ERROR,
    name: i18n.t(`multiselect.single_label.booking_requests.${PAYMENT_ERROR}`),
  },
  {
    code: BOOKING_CONFIRMED,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_CONFIRMED}`),
  },
  {
    code: BOOKING_BOOKED_WITHOUT_PAYMENT,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_BOOKED_WITHOUT_PAYMENT}`),
  },
  {
    code: BOOKING_CONFIRMED_WITHOUT_PAYMENT,
    name: i18n.t(`multiselect.single_label.booking_requests.${BOOKING_CONFIRMED_WITHOUT_PAYMENT}`),
  },
]

export const BOOKING_REQUEST_NEW_TYPE = "new"
export const BOOKING_REQUEST_EXTENSION_TYPE = "extension"

export const BOOKING_REQUEST_TYPES = [
  {
    code: BOOKING_REQUEST_NEW_TYPE,
    name: i18n.t(`multiselect.single_label.booking_request_types.${BOOKING_REQUEST_NEW_TYPE}`),
  },
  {
    code: BOOKING_REQUEST_EXTENSION_TYPE,
    name: i18n.t(`multiselect.single_label.booking_request_types.${BOOKING_REQUEST_EXTENSION_TYPE}`),
  },
]

export const TYPE_BOOKING_REQUEST = "request"
export const TYPE_BOOKING = "booking"

export const BOOKING_TYPES = [
  {
    code: TYPE_BOOKING_REQUEST,
    name: i18n.t(`multiselect.single_label.booking_types.${TYPE_BOOKING_REQUEST}`),
  },
  {
    code: TYPE_BOOKING,
    name: i18n.t(`multiselect.single_label.booking_types.${TYPE_BOOKING}`),
  },
]

export const BALANCE_INITIAL_BALANCE = 1
export const BALANCE_PAYMENT = 2
export const BALANCE_CASH_OUT = 3
export const BALANCE_ELECTRONIC = 4
export const BALANCE_BANK_TRANSFER = 5
export const BALANCE_PURCHASE = 6
export const BALANCE_RENT = 7
export const BALANCE_OTHER = 8

export const PAYMENT_TYPES = [
  {
    code: BALANCE_INITIAL_BALANCE,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_INITIAL_BALANCE}`),
  },
  {
    code: BALANCE_PAYMENT,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_PAYMENT}`),
  },
  {
    code: BALANCE_CASH_OUT,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_CASH_OUT}`),
  },
  {
    code: BALANCE_ELECTRONIC,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_ELECTRONIC}`),
  },
  {
    code: BALANCE_BANK_TRANSFER,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_BANK_TRANSFER}`),
  },
  {
    code: BALANCE_PURCHASE,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_PURCHASE}`),
  },
  {
    code: BALANCE_RENT,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_RENT}`),
  },
  {
    code: BALANCE_OTHER,
    name: i18n.t(`multiselect.single_label.balance_transactions.${BALANCE_OTHER}`),
  },
]

// Products

export const PRODUCT_NAME_MAX_LENGTH = 24
export const PRODUCT_DESCRIPTION_MAX_LENGTH = 200
export const PRODUCT_BARCODE_MAX_LENGTH = 200

export const SHEET_DRAFT = 1
export const SHEET_READY = 2
export const SHEET_PROCESSING = 3
export const SHEET_ACTIVE = 4
export const SHEET_PRINTED = 5

export const PRODUCT_SHEET_STATUSES = [
  {
    code: SHEET_DRAFT,
    name: i18n.t(`multiselect.single_label.product_sheets.${SHEET_DRAFT}`),
  },
  {
    code: SHEET_READY,
    name: i18n.t(`multiselect.single_label.product_sheets.${SHEET_READY}`),
  },
  {
    code: SHEET_PROCESSING,
    name: i18n.t(`multiselect.single_label.product_sheets.${SHEET_PROCESSING}`),
  },
  {
    code: SHEET_ACTIVE,
    name: i18n.t(`multiselect.single_label.product_sheets.${SHEET_ACTIVE}`),
  },
  {
    code: SHEET_PRINTED,
    name: i18n.t(`multiselect.single_label.product_sheets.${SHEET_PRINTED}`),
  },
]

export const PRODUCT_DRAFT = 1
export const PRODUCT_READY = 2
export const PRODUCT_PROCESSING = 3
export const PRODUCT_ACTIVE = 4
export const PRODUCT_PRINTED = 5
export const PRODUCT_SOLD = 6
export const PRODUCT_CHECKED_OUT = 7

export const PRODUCT_STATUSES = [
  {
    code: PRODUCT_DRAFT,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_DRAFT}`),
  },
  {
    code: PRODUCT_READY,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_READY}`),
  },
  {
    code: PRODUCT_PROCESSING,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_PROCESSING}`, { systemName: SYSTEM_NAME }),
  },
  {
    code: PRODUCT_ACTIVE,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_ACTIVE}`, { systemName: SYSTEM_NAME }),
  },
  {
    code: PRODUCT_PRINTED,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_PRINTED}`),
  },
  {
    code: PRODUCT_SOLD,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_SOLD}`),
  },
  {
    code: PRODUCT_CHECKED_OUT,
    name: i18n.t(`multiselect.single_label.products.${PRODUCT_CHECKED_OUT}`),
  },
]

export const EDITABLE_STATUSES = [SHEET_DRAFT, PRODUCT_DRAFT, SHEET_READY, PRODUCT_READY]
export const ACTIVE_STATUSES = [PRODUCT_ACTIVE, PRODUCT_PRINTED]
export const SOLD_STATUSES = [PRODUCT_SOLD]

// Booking

export const AVAILABLE = 0
export const BOOKED = 1
export const BOOKED_PAID = 2
export const RESERVED = 3
export const RESERVED_BOOKING_REQUEST = 4
export const BOOKED_PAID_ONLINE = 5
export const BOOKED_WAITING_PAYMENT = 6
export const BOOKED_WITHOUT_PAYMENT = 7

export const BOOKING_STATUSES = [
  {
    code: AVAILABLE,
    name: i18n.t(`multiselect.single_label.booking.${AVAILABLE}`),
    class: 'available'
  },
  {
    code: BOOKED,
    name: i18n.t(`multiselect.single_label.booking.${BOOKED}`),
    class: 'booked'
  },
  {
    code: BOOKED_PAID,
    name: i18n.t(`multiselect.single_label.booking.${BOOKED_PAID}`),
    class: 'booked-paid'
  },
  {
    code: RESERVED,
    name: i18n.t(`multiselect.single_label.booking.${RESERVED}`),
    class: 'reserved'
  },
    {
    code: RESERVED_BOOKING_REQUEST,
    name: i18n.t(`multiselect.single_label.booking.${RESERVED_BOOKING_REQUEST}`),
    class: 'reserved-booking-request'
  },
  {
    code: BOOKED_PAID_ONLINE,
    name: i18n.t(`multiselect.single_label.booking.${BOOKED_PAID_ONLINE}`),
    class: 'booked-paid-online'
  },
  {
    code: BOOKED_WAITING_PAYMENT,
    name: i18n.t(`multiselect.single_label.booking.${BOOKED_WAITING_PAYMENT}`),
    class: 'booked-waiting-payment'
  },
  {
    code: BOOKED_WITHOUT_PAYMENT,
    name: i18n.t(`multiselect.single_label.booking.${BOOKED_WITHOUT_PAYMENT}`),
    class: 'booked-without-payment'
  },
]

const INFO = 1
const WARNING = 2
const ERROR = 3

export const LEVEL_CHOICES = {
  [INFO]: 'info',
  [WARNING]: 'warning',
  [ERROR]: 'danger',
}

export const DEFAULT_PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [20, 50, 100, 200]

export const SOLO_RECEIPT_FOOTER_MAX_LENGTH = 500

export const DRAFT = 1
export const SENT_TO_ECONOMIC = 2
export const FINALIZED = 3
export const SENT_TO_CUSTOMER = 4
export const COMPLETED_WITHOUT_EMAIL = 5

export const PAYMENT_STATUSES = [
  {
    code: DRAFT,
    name: i18n.t(`multiselect.single_label.pisp.${DRAFT}`),
  },
  {
    code: SENT_TO_ECONOMIC,
    name: i18n.t(`multiselect.single_label.pisp.${SENT_TO_ECONOMIC}`),
  },
  {
    code: FINALIZED,
    name: i18n.t(`multiselect.single_label.pisp.${FINALIZED}`),
  },
  {
    code: SENT_TO_CUSTOMER,
    name: i18n.t(`multiselect.single_label.pisp.${SENT_TO_CUSTOMER}`),
  },
  {
    code: COMPLETED_WITHOUT_EMAIL,
    name: i18n.t(`multiselect.single_label.pisp.${COMPLETED_WITHOUT_EMAIL}`),
  },
]

export const SDC = 'sdc'
export const BEC = 'bec'
export const DANSKE_BANK = 'danske_bank'
export const NORDEA = 'nordea'
export const ISO_20022 = 'iso_20022'
export const BANKDATA = 'bankdata'
export const ISO_20022_IBAN = 'iso_20022_iban'

export const AVAILABLE_BANK_FORMATS = [
  {
    code: SDC,
    name: i18n.t(`multiselect.single_label.bank_export.${SDC}`),
  },
  {
    code: BEC,
    name: i18n.t(`multiselect.single_label.bank_export.${BEC}`),
  },
  {
    code: DANSKE_BANK,
    name: i18n.t(`multiselect.single_label.bank_export.${DANSKE_BANK}`),
  },
  {
    code: NORDEA,
    name: i18n.t(`multiselect.single_label.bank_export.${NORDEA}`),
  },
  {
    code: ISO_20022,
    name: i18n.t(`multiselect.single_label.bank_export.${ISO_20022}`),
  },
  {
    code: BANKDATA,
    name: i18n.t(`multiselect.single_label.bank_export.${BANKDATA}`),
  },
  {
    code: ISO_20022_IBAN,
    name: i18n.t(`multiselect.single_label.bank_export.${ISO_20022_IBAN}`),
  },
]

export const BOOKING_FIELD_HIDDEN = 'hidden'
export const BOOKING_FIELD_OPTIONAL = 'optional'
export const BOOKING_FIELD_REQUIRED = 'required'

export const BOOKING_FIELD_MODES = [
  {
    code: BOOKING_FIELD_HIDDEN,
    name: i18n.t(`multiselect.single_label.booking_field_mode.${BOOKING_FIELD_HIDDEN}`),
  },
  {
    code: BOOKING_FIELD_OPTIONAL,
    name: i18n.t(`multiselect.single_label.booking_field_mode.${BOOKING_FIELD_OPTIONAL}`),
  },
  {
    code: BOOKING_FIELD_REQUIRED,
    name: i18n.t(`multiselect.single_label.booking_field_mode.${BOOKING_FIELD_REQUIRED}`),
  },
]

export const BOOKING_FUTURE_MONTHS_MAX = 12

export const DEFAULT_PRINT = 1
export const ROLL_PRINT = 2

export const PRINT_TYPES = [
  {
    code: DEFAULT_PRINT,
    name: i18n.t(`multiselect.single_label.print_type.${DEFAULT_PRINT}`),
  },
  {
    code: ROLL_PRINT,
    name: i18n.t(`multiselect.single_label.print_type.${ROLL_PRINT}`),
  },
]

export const DEFAULT_DATEPICKER_SHORTCUTS = [
  { key: 'thisWeek', label: i18n.t('datepicker.shortcuts.this_week'), value: 'isoWeek' },
  { key: 'lastWeek', label: i18n.t('datepicker.shortcuts.last_week'), value: '-isoWeek' },
  { key: 'last7Days', label: i18n.t('datepicker.shortcuts.last_7_days'), value: 7 },
  { key: 'last30Days', label: i18n.t('datepicker.shortcuts.last_30_days'), value: 30 },
  { key: 'thisMonth', label: i18n.t('datepicker.shortcuts.this_month'), value: 'month' },
  { key: 'lastMonth', label: i18n.t('datepicker.shortcuts.last_month'), value: '-month' },
  { key: 'thisYear', label: i18n.t('datepicker.shortcuts.this_year'), value: 'year' },
  { key: 'lastYear', label: i18n.t('datepicker.shortcuts.last_year'), value: '-year' }
]

export const DEFAULT_65_BARCODES = 1
export const EXTENDED_40_BARCODES = 2
export const EXTENDED_24_BARCODES = 3

export const SELECTABLE_BOOKING_STATUSES = BOOKING_STATUSES.slice(1)

export const MIN_USER_NUMBER_VALUE = 1000
export const MAX_USER_NUMBER_VALUE = 10000

export const DATE_FORMAT = 'DD-MM-YYYY'
export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm'
export const TIME_FORMAT = 'HH:mm'
export const US_COUNTRY = 'US'
export const DEFAULT_TIMEZONE = 'Europe/Berlin'

export const getDateFormat = (marketCountry = null) => {
  return marketCountry === US_COUNTRY ? 'MM/DD/YYYY' : DATE_FORMAT
}

export const getDateTimeFormat = (marketCountry = null) => {
  return marketCountry === US_COUNTRY ? 'MM/DD/YYYY hh:mm A' : DATE_TIME_FORMAT
}

export const getTimeFormat = (marketCountry = null) => {
  return marketCountry === US_COUNTRY ? 'hh:mm A' : TIME_FORMAT
}

export const ADMIN_SECTION_PATH = '/admin_section#/'
export const USER_SECTION_PATH = '/user#/'
export const LOGIN_SECTION_PATH = '/login/'
export const DJANGO_ADMIN_PATH_NAME = 'admin/'

export const NOVIPOS_URL = 'https://novipos.com'
// Locales without a dedicated guides page fall back to EN at the call site.
export const MOBILE_APP_HELP_URLS = {
  DA: 'https://novipos.com/loppeonline-flealover-vejledninger/',
  DE: 'https://flealover.com/de/kunden-guides/',
  EN: 'https://flealover.com/customer-guides/',
  SV: 'https://flealover.com/se/kundguider/',
  ES: 'https://flealover.com/es/guias-para-clientes/',
  FR: 'https://flealover.com/fr/manuels-clients/',
  NL: 'https://flealover.com/nl/klantenhandleidingen/',
  NO: 'https://flealover.com/no/kundeguider/',
}

export const APP_STORE_URL = 'https://apps.apple.com/us/app/flea-lover/id1567180764'
export const PLAY_MARKET_URL = 'https://play.google.com/store/apps/details?id=com.flealover'

export const INSTAGRAM_MEDIA_TYPE_IMAGE = 'IMAGE'
export const INSTAGRAM_MEDIA_TYPE_VIDEO = 'VIDEO'
export const INSTAGRAM_MEDIA_TYPE_CAROUSEL = 'CAROUSEL_ALBUM'

export const COUNTRY_TIMEZONES = {
  DK: ['Europe/Copenhagen'],
  SE: ['Europe/Stockholm'],
  NO: ['Europe/Oslo'],
  GL: [
    'America/Nuuk',
    'America/Scoresbysund',
    'America/Danmarkshavn',
  ],
  GB: ['Europe/London'],
  DE: ['Europe/Berlin'],
  BR: [
    'America/Sao_Paulo',
    'America/Araguaina',
    'America/Belem',
    'America/Fortaleza',
    'America/Manaus',
    'America/Recife',
    'America/Rio_Branco',
    'America/Bahia',
    'America/Cuiaba',
    'America/Eirunepe',
    'America/Maceio',
    'America/Porto_Velho',
    'America/Santarem',
  ],
  FI: ['Europe/Helsinki'],
  FR: ['Europe/Paris'],
  IT: ['Europe/Rome'],
  MX: [
    'America/Mexico_City',
    'America/Cancun',
    'America/Merida',
    'America/Monterrey',
    'America/Matamoros',
    'America/Chihuahua',
    'America/Hermosillo',
    'America/Mazatlan',
    'America/Ojinaga',
  ],
  NL: ['Europe/Amsterdam'],
  ES: ['Europe/Madrid'],
  US: [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
  ],
}

// Country → currency(ies) mapping for all countries (used for Solo integration)
export const ALL_COUNTRY_CURRENCIES = {"AD":["EUR"],"AE":["AED"],"AF":["AFN"],"AG":["XCD"],"AI":["XCD"],"AL":["ALL"],"AM":["AMD"],"AO":["AOA"],"AR":["ARS"],"AS":["USD"],"AT":["EUR"],"AU":["AUD"],"AW":["AWG"],"AX":["EUR"],"AZ":["AZN"],"BA":["BAM"],"BB":["BBD"],"BD":["BDT"],"BE":["EUR"],"BF":["XOF"],"BG":["BGN"],"BH":["BHD"],"BI":["BIF"],"BJ":["XOF"],"BL":["EUR"],"BM":["BMD"],"BN":["BND"],"BO":["BOB"],"BQ":["USD"],"BR":["BRL"],"BS":["BSD"],"BT":["INR","BTN"],"BV":["NOK"],"BW":["BWP"],"BY":["BYN"],"BZ":["BZD"],"CA":["CAD"],"CC":["AUD"],"CD":["CDF"],"CF":["XAF"],"CG":["XAF"],"CH":["CHF"],"CI":["XOF"],"CK":["NZD"],"CL":["CLP"],"CM":["XAF"],"CN":["CNY"],"CO":["COP"],"CR":["CRC"],"CU":["CUP","CUC"],"CV":["CVE"],"CW":["ANG"],"CX":["AUD"],"CY":["EUR"],"CZ":["CZK"],"DE":["EUR"],"DJ":["DJF"],"DK":["DKK"],"DM":["XCD"],"DO":["DOP"],"DZ":["DZD"],"EC":["USD"],"EE":["EUR"],"EG":["EGP"],"EH":["MAD"],"ER":["ERN"],"ES":["EUR"],"ET":["ETB"],"FI":["EUR"],"FJ":["FJD"],"FK":["FKP"],"FM":["USD"],"FO":["DKK"],"FR":["EUR"],"GA":["XAF"],"GB":["GBP"],"GD":["XCD"],"GE":["GEL"],"GF":["EUR"],"GG":["GBP"],"GH":["GHS"],"GI":["GIP"],"GL":["DKK"],"GM":["GMD"],"GN":["GNF"],"GP":["EUR"],"GQ":["XAF"],"GR":["EUR"],"GS":["GBP"],"GT":["GTQ"],"GU":["USD"],"GW":["XOF"],"GY":["GYD"],"HK":["HKD"],"HM":["AUD"],"HN":["HNL"],"HR":["HRK"],"HT":["HTG","USD"],"HU":["HUF"],"ID":["IDR"],"IE":["EUR"],"IL":["ILS"],"IM":["GBP"],"IN":["INR"],"IO":["USD"],"IQ":["IQD"],"IR":["IRR"],"IS":["ISK"],"IT":["EUR"],"JE":["GBP"],"JM":["JMD"],"JO":["JOD"],"JP":["JPY"],"KE":["KES"],"KG":["KGS"],"KH":["KHR"],"KI":["AUD"],"KM":["KMF"],"KN":["XCD"],"KP":["KPW"],"KR":["KRW"],"KW":["KWD"],"KY":["KYD"],"KZ":["KZT"],"LA":["LAK"],"LB":["LBP"],"LC":["XCD"],"LI":["CHF"],"LK":["LKR"],"LR":["LRD"],"LS":["ZAR","LSL"],"LT":["EUR"],"LU":["EUR"],"LV":["EUR"],"LY":["LYD"],"MA":["MAD"],"MC":["EUR"],"MD":["MDL"],"ME":["EUR"],"MF":["EUR"],"MG":["MGA"],"MH":["USD"],"MK":["MKD"],"ML":["XOF"],"MM":["MMK"],"MN":["MNT"],"MO":["MOP"],"MP":["USD"],"MQ":["EUR"],"MR":["MRU"],"MS":["XCD"],"MT":["EUR"],"MU":["MUR"],"MV":["MVR"],"MW":["MWK"],"MX":["MXN"],"MY":["MYR"],"MZ":["MZN"],"NA":["ZAR","NAD"],"NC":["XPF"],"NE":["XOF"],"NF":["AUD"],"NG":["NGN"],"NI":["NIO"],"NL":["EUR"],"NO":["NOK"],"NP":["NPR"],"NR":["AUD"],"NU":["NZD"],"NZ":["NZD"],"OM":["OMR"],"PA":["PAB","USD"],"PE":["PEN"],"PF":["XPF"],"PG":["PGK"],"PH":["PHP"],"PK":["PKR"],"PL":["PLN"],"PM":["EUR"],"PN":["NZD"],"PR":["USD"],"PS":["ILS","JOD"],"PT":["EUR"],"PW":["USD"],"PY":["PYG"],"QA":["QAR"],"RE":["EUR"],"RO":["RON"],"RS":["RSD"],"RU":["RUB"],"RW":["RWF"],"SA":["SAR"],"SB":["SBD"],"SC":["SCR"],"SD":["SDG"],"SE":["SEK"],"SG":["SGD"],"SH":["SHP"],"SI":["EUR"],"SJ":["NOK"],"SK":["EUR"],"SL":["SLL"],"SM":["EUR"],"SN":["XOF"],"SO":["SOS"],"SR":["SRD"],"SS":["SSP"],"ST":["STN"],"SV":["USD"],"SX":["ANG"],"SY":["SYP"],"SZ":["SZL"],"TC":["USD"],"TD":["XAF"],"TF":["EUR"],"TG":["XOF"],"TH":["THB"],"TJ":["TJS"],"TK":["NZD"],"TL":["USD"],"TM":["TMT"],"TN":["TND"],"TO":["TOP"],"TR":["TRY"],"TT":["TTD"],"TV":["AUD"],"TW":["TWD"],"TZ":["TZS"],"UA":["UAH"],"UG":["UGX"],"UM":["USD"],"US":["USD"],"UY":["UYU"],"UZ":["UZS"],"VA":["EUR"],"VC":["XCD"],"VE":["VES"],"VG":["USD"],"VI":["USD"],"VN":["VND"],"VU":["VUV"],"WF":["XPF"],"WS":["WST"],"YE":["YER"],"YT":["EUR"],"ZA":["ZAR"],"ZM":["ZMW"],"ZW":["USD"]}

// Full pytz country_timezones for all 247 countries (used for Solo integration)
export const ALL_COUNTRY_TIMEZONES = {"AD":["Europe/Andorra"],"AE":["Asia/Dubai"],"AF":["Asia/Kabul"],"AG":["America/Antigua"],"AI":["America/Anguilla"],"AL":["Europe/Tirane"],"AM":["Asia/Yerevan"],"AO":["Africa/Luanda"],"AQ":["Antarctica/McMurdo","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok"],"AR":["America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia"],"AS":["Pacific/Pago_Pago"],"AT":["Europe/Vienna"],"AU":["Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla"],"AW":["America/Aruba"],"AX":["Europe/Mariehamn"],"AZ":["Asia/Baku"],"BA":["Europe/Sarajevo"],"BB":["America/Barbados"],"BD":["Asia/Dhaka"],"BE":["Europe/Brussels"],"BF":["Africa/Ouagadougou"],"BG":["Europe/Sofia"],"BH":["Asia/Bahrain"],"BI":["Africa/Bujumbura"],"BJ":["Africa/Porto-Novo"],"BL":["America/St_Barthelemy"],"BM":["Atlantic/Bermuda"],"BN":["Asia/Brunei"],"BO":["America/La_Paz"],"BQ":["America/Kralendijk"],"BR":["America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco"],"BS":["America/Nassau"],"BT":["Asia/Thimphu"],"BW":["Africa/Gaborone"],"BY":["Europe/Minsk"],"BZ":["America/Belize"],"CA":["America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Iqaluit","America/Atikokan","America/Winnipeg","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","America/Dawson","America/Vancouver"],"CC":["Indian/Cocos"],"CD":["Africa/Kinshasa","Africa/Lubumbashi"],"CF":["Africa/Bangui"],"CG":["Africa/Brazzaville"],"CH":["Europe/Zurich"],"CI":["Africa/Abidjan"],"CK":["Pacific/Rarotonga"],"CL":["America/Santiago","America/Punta_Arenas","Pacific/Easter"],"CM":["Africa/Douala"],"CN":["Asia/Shanghai","Asia/Urumqi"],"CO":["America/Bogota"],"CR":["America/Costa_Rica"],"CU":["America/Havana"],"CV":["Atlantic/Cape_Verde"],"CW":["America/Curacao"],"CX":["Indian/Christmas"],"CY":["Asia/Nicosia","Asia/Famagusta"],"CZ":["Europe/Prague"],"DE":["Europe/Berlin","Europe/Busingen"],"DJ":["Africa/Djibouti"],"DK":["Europe/Copenhagen"],"DM":["America/Dominica"],"DO":["America/Santo_Domingo"],"DZ":["Africa/Algiers"],"EC":["America/Guayaquil","Pacific/Galapagos"],"EE":["Europe/Tallinn"],"EG":["Africa/Cairo"],"EH":["Africa/El_Aaiun"],"ER":["Africa/Asmara"],"ES":["Europe/Madrid","Africa/Ceuta","Atlantic/Canary"],"ET":["Africa/Addis_Ababa"],"FI":["Europe/Helsinki"],"FJ":["Pacific/Fiji"],"FK":["Atlantic/Stanley"],"FM":["Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae"],"FO":["Atlantic/Faroe"],"FR":["Europe/Paris"],"GA":["Africa/Libreville"],"GB":["Europe/London"],"GD":["America/Grenada"],"GE":["Asia/Tbilisi"],"GF":["America/Cayenne"],"GG":["Europe/Guernsey"],"GH":["Africa/Accra"],"GI":["Europe/Gibraltar"],"GL":["America/Nuuk","America/Danmarkshavn","America/Scoresbysund","America/Thule"],"GM":["Africa/Banjul"],"GN":["Africa/Conakry"],"GP":["America/Guadeloupe"],"GQ":["Africa/Malabo"],"GR":["Europe/Athens"],"GS":["Atlantic/South_Georgia"],"GT":["America/Guatemala"],"GU":["Pacific/Guam"],"GW":["Africa/Bissau"],"GY":["America/Guyana"],"HK":["Asia/Hong_Kong"],"HN":["America/Tegucigalpa"],"HR":["Europe/Zagreb"],"HT":["America/Port-au-Prince"],"HU":["Europe/Budapest"],"ID":["Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura"],"IE":["Europe/Dublin"],"IL":["Asia/Jerusalem"],"IM":["Europe/Isle_of_Man"],"IN":["Asia/Kolkata"],"IO":["Indian/Chagos"],"IQ":["Asia/Baghdad"],"IR":["Asia/Tehran"],"IS":["Atlantic/Reykjavik"],"IT":["Europe/Rome"],"JE":["Europe/Jersey"],"JM":["America/Jamaica"],"JO":["Asia/Amman"],"JP":["Asia/Tokyo"],"KE":["Africa/Nairobi"],"KG":["Asia/Bishkek"],"KH":["Asia/Phnom_Penh"],"KI":["Pacific/Tarawa","Pacific/Kanton","Pacific/Kiritimati"],"KM":["Indian/Comoro"],"KN":["America/St_Kitts"],"KP":["Asia/Pyongyang"],"KR":["Asia/Seoul"],"KW":["Asia/Kuwait"],"KY":["America/Cayman"],"KZ":["Asia/Almaty","Asia/Qyzylorda","Asia/Qostanay","Asia/Aqtobe","Asia/Aqtau","Asia/Atyrau","Asia/Oral"],"LA":["Asia/Vientiane"],"LB":["Asia/Beirut"],"LC":["America/St_Lucia"],"LI":["Europe/Vaduz"],"LK":["Asia/Colombo"],"LR":["Africa/Monrovia"],"LS":["Africa/Maseru"],"LT":["Europe/Vilnius"],"LU":["Europe/Luxembourg"],"LV":["Europe/Riga"],"LY":["Africa/Tripoli"],"MA":["Africa/Casablanca"],"MC":["Europe/Monaco"],"MD":["Europe/Chisinau"],"ME":["Europe/Podgorica"],"MF":["America/Marigot"],"MG":["Indian/Antananarivo"],"MH":["Pacific/Majuro","Pacific/Kwajalein"],"MK":["Europe/Skopje"],"ML":["Africa/Bamako"],"MM":["Asia/Yangon"],"MN":["Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan"],"MO":["Asia/Macau"],"MP":["Pacific/Saipan"],"MQ":["America/Martinique"],"MR":["Africa/Nouakchott"],"MS":["America/Montserrat"],"MT":["Europe/Malta"],"MU":["Indian/Mauritius"],"MV":["Indian/Maldives"],"MW":["Africa/Blantyre"],"MX":["America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Chihuahua","America/Ciudad_Juarez","America/Ojinaga","America/Mazatlan","America/Bahia_Banderas","America/Hermosillo","America/Tijuana"],"MY":["Asia/Kuala_Lumpur","Asia/Kuching"],"MZ":["Africa/Maputo"],"NA":["Africa/Windhoek"],"NC":["Pacific/Noumea"],"NE":["Africa/Niamey"],"NF":["Pacific/Norfolk"],"NG":["Africa/Lagos"],"NI":["America/Managua"],"NL":["Europe/Amsterdam"],"NO":["Europe/Oslo"],"NP":["Asia/Kathmandu"],"NR":["Pacific/Nauru"],"NU":["Pacific/Niue"],"NZ":["Pacific/Auckland","Pacific/Chatham"],"OM":["Asia/Muscat"],"PA":["America/Panama"],"PE":["America/Lima"],"PF":["Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier"],"PG":["Pacific/Port_Moresby","Pacific/Bougainville"],"PH":["Asia/Manila"],"PK":["Asia/Karachi"],"PL":["Europe/Warsaw"],"PM":["America/Miquelon"],"PN":["Pacific/Pitcairn"],"PR":["America/Puerto_Rico"],"PS":["Asia/Gaza","Asia/Hebron"],"PT":["Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores"],"PW":["Pacific/Palau"],"PY":["America/Asuncion"],"QA":["Asia/Qatar"],"RE":["Indian/Reunion"],"RO":["Europe/Bucharest"],"RS":["Europe/Belgrade"],"RU":["Europe/Kaliningrad","Europe/Moscow","Europe/Kirov","Europe/Volgograd","Europe/Astrakhan","Europe/Saratov","Europe/Ulyanovsk","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Tomsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr"],"RW":["Africa/Kigali"],"SA":["Asia/Riyadh"],"SB":["Pacific/Guadalcanal"],"SC":["Indian/Mahe"],"SD":["Africa/Khartoum"],"SE":["Europe/Stockholm"],"SG":["Asia/Singapore"],"SH":["Atlantic/St_Helena"],"SI":["Europe/Ljubljana"],"SJ":["Arctic/Longyearbyen"],"SK":["Europe/Bratislava"],"SL":["Africa/Freetown"],"SM":["Europe/San_Marino"],"SN":["Africa/Dakar"],"SO":["Africa/Mogadishu"],"SR":["America/Paramaribo"],"SS":["Africa/Juba"],"ST":["Africa/Sao_Tome"],"SV":["America/El_Salvador"],"SX":["America/Lower_Princes"],"SY":["Asia/Damascus"],"SZ":["Africa/Mbabane"],"TC":["America/Grand_Turk"],"TD":["Africa/Ndjamena"],"TF":["Indian/Kerguelen"],"TG":["Africa/Lome"],"TH":["Asia/Bangkok"],"TJ":["Asia/Dushanbe"],"TK":["Pacific/Fakaofo"],"TL":["Asia/Dili"],"TM":["Asia/Ashgabat"],"TN":["Africa/Tunis"],"TO":["Pacific/Tongatapu"],"TR":["Europe/Istanbul"],"TT":["America/Port_of_Spain"],"TV":["Pacific/Funafuti"],"TW":["Asia/Taipei"],"TZ":["Africa/Dar_es_Salaam"],"UA":["Europe/Simferopol","Europe/Kyiv"],"UG":["Africa/Kampala"],"UM":["Pacific/Midway","Pacific/Wake"],"US":["America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu"],"UY":["America/Montevideo"],"UZ":["Asia/Samarkand","Asia/Tashkent"],"VA":["Europe/Vatican"],"VC":["America/St_Vincent"],"VE":["America/Caracas"],"VG":["America/Tortola"],"VI":["America/St_Thomas"],"VN":["Asia/Ho_Chi_Minh"],"VU":["Pacific/Efate"],"WF":["Pacific/Wallis"],"WS":["Pacific/Apia"],"YE":["Asia/Aden"],"YT":["Indian/Mayotte"],"ZA":["Africa/Johannesburg"],"ZM":["Africa/Lusaka"],"ZW":["Africa/Harare"]}

